var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.442 8.99951V1.68555H12.442H1.5H0.5V13.6275V14.6275H9.30879",
    stroke: "#0B1B4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7648 15.4983C13.6541 15.4983 15.1858 13.9666 15.1858 12.0773C15.1858 10.1879 13.6541 8.65625 11.7648 8.65625C9.87538 8.65625 8.34375 10.1879 8.34375 12.0773C8.34375 13.9666 9.87538 15.4983 11.7648 15.4983Z",
    stroke: "#0B1B4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79297 0V3.244",
    stroke: "#0B1B4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14844 0V3.244",
    stroke: "#0B1B4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.4375 5.10742H13.5085",
    stroke: "#0B1B4E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 1,
    height: 1,
    fill: "#011F53"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 1,
    height: 1,
    fill: "#011F53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 10.3457V12.5277L13.0856 13.8217",
    stroke: "#0B1B4E",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendsIcon);
export default __webpack_public_path__ + "static/media/Attends-icon.6ec288111e43d5203566baa5e56bd19b.svg";
export { ForwardRef as ReactComponent };